import { type CostCenter } from "@finway-group/shared/lib/models"
import { Select, type SelectProps } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { DeletedTooltip } from "~Components/deletedTooltip"
import { useCostCenterById } from "~Shared/hooks/costCenter.hooks"
import { getCostCenterLabel } from "~Shared/utils/costCenter.utils"
import { doFilterSelect } from "~Shared/utils/helper.utils"
import { type GetPopupAnchor } from "~Shared/utils/popup.utils"

interface CostCenterSelectProps extends SelectProps {
    costCenters: Array<CostCenter>
    showCostCentersIds: boolean
    getPopupAnchor: GetPopupAnchor
}

export const CostCenterSelect = ({ costCenters, showCostCentersIds, getPopupAnchor, ...selectProps }: CostCenterSelectProps) => {
    const { t } = useTranslation()
    const placeholder = selectProps?.placeholder || t("placeholder:cost_center.select_a_cost_center")

    const selectedCostCenter = useCostCenterById(selectProps.value)
    return (
        <Select data-testid="finway:costCenterSelect" {...selectProps} showSearch filterOption={doFilterSelect} getPopupContainer={getPopupAnchor()} placeholder={placeholder}>
            {selectedCostCenter?.deleted && (
                <Select.Option
                    key={costCenters.length}
                    value={selectedCostCenter._id}
                    id={`costcenter-option-${costCenters.length}`}
                    label={getCostCenterLabel(selectedCostCenter, showCostCentersIds)}
                >
                    <div>
                        {getCostCenterLabel(selectedCostCenter, showCostCentersIds)}
                        <DeletedTooltip translationKey="tooltips:cost_center.was_deleted" deletionDate={selectedCostCenter.dateDeleted} />
                    </div>
                </Select.Option>
            )}
            {costCenters.map(({ _id, id, name }, idx) => (
                <Select.Option key={idx} value={_id} id={`costcenter-option-${idx}`} label={`ID ${id} - ${name}`} data-testid={`finway:costCenterSelect:option:${name}`}>
                    {showCostCentersIds ? `ID ${id} - ${name}` : name}
                </Select.Option>
            ))}
        </Select>
    )
}
